import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import {actions} from '../constants/address/shipping_address_actions';
import ShippingAddress from './models/shipping_address';

class ShippingAddressStoreClass extends ReduceStore {
    getInitialState() {
        return {
            address: new ShippingAddress,
            invalid: [],
            autoSuggestResult: [],
        };
    }

    reduce( state, { source, action } ) {
        if ( source === ACTION_TYPES.SHIPPING_ADDRESS_ACTION ) {
            switch (action.type) {
                case actions.SET_STREET:
                    if (action.payload !== state.address.street) {
                        state.address.street = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_STREET_NUMBER:
                    if (action.payload !== state.address.streetNumber) {
                        state.address.streetNumber = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_SUBURB:
                    if (action.payload !== state.address.suburb) {
                        state.address.suburb = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_CITY:
                    if (action.payload !== state.address.city) {
                        state.address.city = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_STATE:
                    if (action.payload !== state.address.state) {
                        state.address.state = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_FIRST_NAME:
                    if (action.payload !== state.address.firstName) {
                        state.address.firstName = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_LAST_NAME:
                    if (action.payload !== state.address.lastName) {
                        state.address.lastName = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_EMAIL:
                    if (action.payload !== state.address.email) {
                        state.address.email = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_TELEPHONE:
                    if (action.payload !== state.address.telephone) {
                        state.address.telephone = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_POSTCODE:
                    if (action.payload !== state.address.postcode) {
                        state.address.postcode = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_ADDRESS_TYPE:
                    if (action.payload !== state.address.addressType) {
                        state.address.addressType = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_COUNTRY:
                    if (action.payload !== state.address.country) {
                        state.address.country = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.SET_INVALID:
                    if (state.invalid.indexOf(action.payload) < 0) {
                        state.invalid.push(action.payload);
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_INVALID:
                    if (state.invalid.indexOf(action.payload) > -1) {
                        state.invalid.splice(state.invalid.indexOf(action.payload), 1);
                        this.__emitChange();
                    }
                    break;
                case actions.RESET_INVALID:
                    state.invalid = [];
                    this.__emitChange();
                    break;
                case actions.SET_AUTOSUGGEST_RESULT:
                    if (state.autoSuggestResult !== action.payload) {
                        state.autoSuggestResult = action.payload;
                    }
                    this.__emitChange();
                    break;
                case actions.CLEAR_AUTOSUGGEST_RESULT:
                    state.autoSuggestResult = [];
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const ShippingAddressStore = new ShippingAddressStoreClass( Dispatcher );
export default ShippingAddressStore;
